<template>   
  <b-card-text>
    <b-row class="mb-1">
      <b-col sm="12">
        <b-button @click="add()" type="button" variant="link" class="list-view-icon-btn list-view-icon-btn--primary float-right" v-b-tooltip.hover title="Agregar Percepción" aria-label="Agregar Percepción">
          <AppIcon name="add" />
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col>
        <b-table class="app-table mb-0"
              stacked="md"
              :hover="true"
              :small="true"
              :fixed="false"
              :items="table.items"
              :fields="table.fields"
              :filter="table.filter"
              :current-page="table.currentPage"
              :per-page="table.perPage"
              v-if="table.items.length">

          <template v-slot:cell(id)="data">
            <b>{{ data.item.id }}</b>
          </template>

          <template v-slot:cell(name)="data">
            {{ data.item.name }}
          </template>

          <template v-slot:cell(aliquot)="data">
            {{ data.item.aliquot }}
          </template>

          <template v-slot:cell(accounting_account_secondary)="data">
            <div v-if="data.item.accounting_account_secondary_rel">
              {{ data.item.accounting_account_secondary_rel.code }} - {{ data.item.accounting_account_secondary_rel.name }}
            </div>
          </template>

          <template v-slot:cell(f_action)="data">
            <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle">
              <template #button-content><AppIcon name="more_vert" label="Opciones" /><span class="app-table-action-label">Opciones</span></template>
              <b-dropdown-header>Acciones</b-dropdown-header>                                                           
              
              <b-dropdown-item @click="edit(data.item)">
                <AppIcon name="edit" class="mr-1" /> Editar
              </b-dropdown-item>
              <b-dropdown-item @click="remove(data.item)">
                <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <EmptyState v-else icon="percent" title="No hay percepciones" description="Agregá una percepción para aplicarla en los comprobantes." />
      </b-col>
    </b-row>
                        
    <b-row>
      <b-col>
        <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
          <AppIcon name="back" class="mr-1" />
          Volver
        </b-button>                        
      </b-col>

      <b-col>
        <nav>
          <b-pagination class="pull-right mb-0"
                        size="sm"
                        pills=""
                        :total-rows="getRowCount(table.items)"
                        :per-page="table.perPage"
                        v-model="table.currentPage" />
        </nav>
      </b-col> 
    </b-row>            

    <!-- ########################### -->
    <!-- #####     MODALES     ##### -->
    <!-- ########################### -->

    <b-modal v-model="modal.form.active"
            body-class="app-modal-form"
            :key="modal.form._id"
            :id="modal.form._id">                

        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="percent" /></span>
          <h5 class="app-modal-header__title">{{ modal.form.title }}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Percepción">
              <b-form-input type="text"
                              size="sm"
                              v-model="crud.form.name"
                              required>
              </b-form-input>
            </b-form-group>
          </b-col>                    
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="Alicuota">
              <b-form-input type="number"
                              size="sm"
                              v-model="crud.form.aliquot">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="showContabilidad">
          <b-col md="12">
            <FindObject render="search"
                        tag="Cuenta Contable de Compra"
                        type="accountingAccountsImputation" 
                        @select-object="loadAccountingAccountsSecondary($event)" 
                        :valueID="crud.form.accounting_accounts_secondary_id"
                        :where="conditionAccountingAccountsFiltersSecondary"/>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false"><AppIcon name="x" class="mr-1" />Cancelar</b-button>
          <b-button variant="primary" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
    </b-modal>    
  </b-card-text>                                
</template>

<script>
  import serviceAPI from './../services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Modules from '@/config/modules'
  import FindObject from '@/components/inc/find/findObject'  

  export default {
    components: {
      FindObject,        
    },  
    data: () => {
      return {      
        table : {
          items: [],
          fields: [],                    
          currentPage: 1,
          perPage: 50,
        },
        crud: {
          form: {
            id: 0,
            name: '',
            aliquot: 0,
            accounting_accounts_secondary: null,
            accounting_accounts_secondary_id: 0,
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },
      }
    },
    mounted () {
      this.show()
      this.loadFieldTable()
    },
    computed: {
      // CONDITIONS SELECT  
      conditionAccountingAccountsFiltersSecondary(){
        return [
          {field: 'active', condition: true},
          {field: 'type', condition: 'Activo'}
        ];
      },  

      // MODULES
      showContabilidad() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.CONTABILIDAD) {                             
            status = true                       
          }
        })        
        return status
      },        
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      loadFieldTable() {
        this.table.fields.push({key: 'id', label: 'ID', sortable: true, class:"align-middle"})
        this.table.fields.push({key: 'name', label: 'Nombre', class:"align-middle"})
        this.table.fields.push({key: 'aliquot', label: 'Alicuota', class:"align-middle text-center"})
        
        if(this.showContabilidad) {
          this.table.fields.push({key: 'accounting_account_secondary', label: 'Cuenta Contable de Compra', class:"align-middle"})
        }
        
        this.table.fields.push({key: 'f_action', label:'', class:"align-middle"})
      },      
      show() {        
        var result = serviceAPI.obtenerPercepciones()

        result.then((response) => {
          var data = response.data
          this.table.items = data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });  
      },
      add() {
        this.crud.form.id = 0                
        this.crud.form.name = ''
        this.crud.form.aliquot = 0,
        this.crud.form.accounting_accounts_secondary = null,
        this.crud.form.accounting_accounts_secondary_id = 0,

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Percepción"
        this.modal.form.active = true
      },
      edit(item) {                
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.aliquot = item.aliquot,
        this.crud.form.accounting_accounts_secondary = item.accounting_accounts_secondary_rel,
        this.crud.form.accounting_accounts_secondary_id = item.accounting_accounts_secondary_id

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Percepción"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.aliquot = item.aliquot,
        this.crud.form.accounting_accounts_secondary = item.accounting_accounts_secondary_rel,
        this.crud.form.accounting_accounts_secondary_id = item.accounting_accounts_secondary_id

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Percepción',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarPercepcion(this.crud.form.id);

            result.then(() => {      
              this.modal.form.active = false        
              loader.hide()
              this.show()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarPercepcion(this.crud.form);
        } else {
          result = serviceAPI.agregarPercepcion(this.crud.form);
        }

        result.then(() => {
          this.modal.form.active = false
          loader.hide()
          this.show()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },


      loadAccountingAccountsSecondary (object) {
        if(object){
          this.crud.form.accounting_accounts_secondary = object
          this.crud.form.accounting_accounts_secondary_id = object.id             
        } else {
          this.crud.form.accounting_accounts_secondary = null
          this.crud.form.accounting_accounts_secondary_id = 0
        }
      },
    } 
  }
</script>
